import PulseApi from '../api/PulseApi';
import RootStore from '../store/RootStore';
import type { AppConfig } from './AppConfig';
import type Application from './Application';

export default function createApplication(appConfig: AppConfig): Application {
  const api = createApiInstance(appConfig);
  const store = createStore({ appConfig, api });

  return {
    api,
    appConfig,
    store,
  };
}

function createApiInstance(appConfig: AppConfig): PulseApi {
  const api = new PulseApi({
    isLoggingEnabled: appConfig.isDebuggingEnabled,
    baseUrl: appConfig.apiEndpointUrl,
    ...appConfig.apiOptions,
  });

  if (appConfig.isDebuggingEnabled) {
    api.onLog(({ method, url, duration, body, response }) => {
      console.groupCollapsed(`${method} ${url} in ${duration}ms`);
      if (body) {
        console.debug('Body', body);
      }

      if (response) {
        console.debug('Response', response);
      }

      console.groupEnd();
    });
  }

  return api;
}

function createStore({
  appConfig,
  api,
}: {
  api: PulseApi;
  appConfig: AppConfig;
}) {
  const store = new RootStore({
    appConfig,
    api,
  });

  if (appConfig.isDebuggingEnabled && typeof window !== 'undefined') {
    (window as any).store = store;
  }

  return store;
}
